import type { MessageKey } from "./ru"

export const tgMessages = {
  "common.loading": "Бор шуда истодааст...",
  "common.error": "Хато",
  "common.back": "Бозгашт",
  "common.next": "Давом",
  "common.search": "Ҷустуҷӯ",
  "auth.loginErrorTitle": "Хатои воридшавӣ",
  "auth.openViaTelegram": "Барномаро тавассути Telegram кушоед",
  "auth.telegramRequired": "Барнома бояд тавассути Telegram кушода шавад",
  "auth.authorizationError": "Хатои авторизатсия",
  "device.rotatePortrait": "Дастгоҳро ба ҳолати амудӣ гардонед",
  "country.brazil": "Бразилия",
  "country.vietnam": "Ветнам",
  "country.egypt": "Миср",
  "country.india": "Ҳиндустон",
  "country.indonesia": "Индонезия",
  "country.iran": "Эрон",
  "country.spain": "Испания",
  "country.italy": "Италия",
  "country.kazakhstan": "Қазоқистон",
  "country.colombia": "Колумбия",
  "country.malaysia": "Малайзия",
  "country.mexico": "Мексика",
  "country.nigeria": "Нигерия",
  "country.pakistan": "Покистон",
  "country.russia": "Русия",
  "country.usa": "ИМА",
  "country.turkey": "Туркия",
  "country.uzbekistan": "Ӯзбекистон",
  "country.ukraine": "Украина",
  "country.philippines": "Филиппин",
  "countrySelection.chooseCountry": "Кишварро интихоб кунед",
  "countrySelection.openAria": "Интихоби кишвар",
  "languageSelection.chooseLanguage": "Забонро интихоб кунед",
  "commercial.direction.autotrade": "Бозори мошин",
  "commercial.direction.insurance": "Суғурта",
  "commercial.direction.pitstop": "Пит-стоп",
  "commercial.direction.techhelp": "Кӯмак дар роҳ",
  "commercial.searchLabel": "Ҷустуҷӯи BeepApp",
  "commercial.cityPlaceholder": "Шаҳрро ворид кунед",
  "commercial.emptyTitle": "Имрӯз пешниҳод нест",
  "commercial.emptyLine1": "Дар шаҳри шумо ҳоло шарикони фаъоли BeepApp нестанд",
  "commercial.emptyLine2": "Мо аллакай барои ёфтан ва пайваст кардани онҳо кор мекунем",
  "commercial.emptyLine3": "Пешниҳодҳои нав дар ин ҷо худкор пайдо мешаванд",
  "commercial.helperLine1": "Барои дидани пешниҳодҳои дастрас",
  "commercial.helperLine2": "шаҳри худро ворид кунед",
  "commercial.partnerPrompt": "Мехоҳед шарики BeepApp шавед?",
  "commercial.apply": "Дархост додан",
  "main.admin": "Админ",
  "main.garage": "Гараж",
  "main.signalSent": "Сигнал фиристода шуд",
  "main.partnerInviteUnavailable": "Даъвати шарикӣ дастнорас аст",
  "main.enterPlate": "Рақами давлатиро ворид кунед",
  "main.searchError": "Хатои ҷустуҷӯ",
  "main.signalSendError": "Сигнал фиристода нашуд",
  "main.shareCardPrefix": "Корти рақам",
  "main.shareLinkError": "Омода кардани пайванд муяссар нашуд",
  "main.searchByPlateAria": "Ҷустуҷӯ аз рӯи рақами давлатӣ",
  "main.russianPlateAria": "Рақами давлатии Русия",
  "main.plateAria": "Рақами давлатӣ",
  "main.findPlateAria": "Ёфтани рақам",
  "main.loadingVehicle": "Корти рақам бор шуда истодааст…",
  "main.leaveSignal": "Фиристодани сигнал",
  "main.share": "Мубодила",
  "signalSelection.chooseType": "Навъи сигналро интихоб кунед",
  "signalSelection.category.attention": "Шахсӣ",
  "signalSelection.category.road": "Роҳ",
  "signalSelection.category.urgent": "Фаврӣ",
  "signalSelection.chooseSignal": "Сигналро интихоб кунед",
  "signalSelection.suggestOwn": "Варианти худро пешниҳод кунед",
  "signalConfirmation.title": "Сигналро тасдиқ кунед",
  "signalConfirmation.plateHeading": "Рақами давлатиро санҷед",
  "signalConfirmation.signalHeading": "Сигнали интихобшударо санҷед",
  "signalConfirmation.replyTitle": "Иҷозаи ҷавоб дар Telegram",
  "signalConfirmation.replyBody": "Инро фаъол кунед, то соҳиби рақам тавонад\nдар Telegram ба шумо нависад. Ҷавоб танҳо агар\nшумо @username дошта бошед имконпазир аст. Қарори ҷавоб додан\nдар ихтиёри соҳиби рақам мемонад.",
  "signalConfirmation.consentText": "Тасдиқ мекунам, ки ин сигнал ба\nвазъияти воқеӣ мувофиқ аст ва спам\nё хабари бардурӯғ нест.",
  "signalConfirmation.warning": "Пас аз фиристодан сигналро\nтағйир додан мумкин нест",
  "signalConfirmation.sending": "Фиристода мешавад…",
  "signalConfirmation.send": "Фиристодан",
  "partner.loadingAria": "Боркунӣ",
  "partner.title": "Барномаи шарикӣ",
  "partner.offerLine1": "Аз ҳамаи пардохтҳо бемӯҳлат 30% гиред",
  "partner.offerLine2": "аз корбароне, ки шумо ба BeepApp даъват мекунед",
  "partner.offerLine3": "тавассути барномаи шарикии Telegram",
  "partner.connectUnavailable": "Пайвастшавӣ пас аз танзими Telegram Affiliate Program дастрас мешавад.",
  "partner.connectTelegram": "Дар Telegram пайваст кардан",
  "partner.qrAria": "QR-коди пайванди шарикӣ",
  "partner.download": "Боргирӣ",
  "partner.promoHeading": "Промокоди шахсӣ созед",
  "partner.promoHelperLine1": "Промокод як соли иловагии обунаро фаъол мекунад",
  "partner.promoHelperLine2": "ва барои ҷалби корбарон кӯмак мекунад",
  "partner.promoAria": "Промокод",
  "partner.affiliateHeading": "Пайванди шарикии шумо",
  "partner.affiliateHelper": "Пайвандро барои сохтани QR-коди шахсӣ нигоҳ доред",
  "partner.affiliateAria": "Пайванди шарикӣ",
  "partner.qrNoteLine1": "QR-кодро метавон дар мошини шумо,",
  "partner.qrNoteLine2": "дар шабакаҳои иҷтимоӣ ва маводи таблиғотӣ ҷойгир кард",
  "partner.save": "Нигоҳ доштан",
  "partner.reset": "Барқарор кардан",
  "partner.resetConfirm": "Пайванди шарикии нигоҳдошташударо барқарор мекунед? Промокод барои шумо мемонад.",
  "partner.promoFormatError": "Промокод бояд аз 4 то 15 аломат дошта бошад.",
  "partner.affiliateHostError": "Танҳо пайвандҳои t.me ё telegram.me иҷозат дода мешаванд.",
  "partner.affiliatePathError": "Пайванд роҳи Telegram надорад.",
  "partner.affiliateFormatError": "Пайванди шарикӣ нодуруст аст.",
  "partner.loadError": "Хатои боркунӣ",
  "partner.checkInputError": "Маълумоти воридшударо санҷед",
  "garageActivation.promoInvalid": "Промокод нодуруст аст",
  "garageActivation.plateOccupied": "Ин рақами давлатӣ аллакай пайваст шудааст",
  "garageActivation.activateError": "Гаражро фаъол кардан муяссар нашуд",
  "garageEntry.loadJournalError": "Бор кардани журнали сафар муяссар нашуд",
  "garageEntry.loadStatusesError": "Бор кардани статусҳо муяссар нашуд",
  "garageEntry.activationSuccess": "Гараж бомуваффақият фаъол шуд",
  "garageEntry.plateAttached": "Рақам пайваст шуд",
  "garageEntry.attachError": "Пайваст кардани рақам муяссар нашуд",
  "garageEntry.activationNote": "Гаражи худро фаъол кунед",
  "garageSheet.activationTitle": "Фаъолсозии Гараж",
  "garageSheet.plateHelper": "Рақами давлатии мошинро ворид кунед",
  "garageSheet.promoHelper": "Промокод доред?",
  "garageSheet.cleanBonusLine1": "Пас аз фаъолсозӣ шумо 1 соат доред",
  "garageSheet.cleanBonusLine2": "барои «Оғози тоза»-и ройгон",
  "garageSheet.activationFor": "Фаъолсозӣ барои",
  "garageSheet.cost": "Арзиш",
  "garageSheet.ownerConsentLine1": "Тасдиқ мекунам, ки соҳиби",
  "garageSheet.ownerConsentLine2": "мошин бо рақами давлатии",
  "garageSheet.ownerConsentLine3": "нишондодашуда ҳастам.",
  "garageSheet.processing": "Коркард...",
  "garageSheet.attach": "Пайваст кардан",
  "garageSheet.pay": "Пардохт",
  "garageLifecycle.cleanTitle": "Оғози тоза",
  "garageLifecycle.deactivateTitle": "Ғайрифаъолсозии Гараж",
  "garageLifecycle.cleanWarningLine1": "Таърихи рақам нест карда мешавад",
  "garageLifecycle.cleanWarningLine2": "бе имкони барқароркунӣ!",
  "garageLifecycle.deactivateWarningLine1": "Пас аз ғайрифаъолсозӣ дастрасӣ ба",
  "garageLifecycle.deactivateWarningLine2": "функсияҳои фаъоли Гараж қатъ мешавад",
  "garageLifecycle.willBeDeleted": "НЕСТ КАРДА МЕШАВАД",
  "garageLifecycle.cleanRemovedLine1": "• Ҳамаи сабтҳои Журнали сафар",
  "garageLifecycle.cleanRemovedLine2": "• Таърихи сигналҳои гирифташуда",
  "garageLifecycle.cleanRemovedLine3": "• Ҳисобкунакҳои оммавии сигналҳо",
  "garageLifecycle.cleanRemovedLine4": "  дар корти рақам",
  "garageLifecycle.willRemain": "БОҚӢ МЕМОНАД",
  "garageLifecycle.cleanPreservedLine1": "• Пайвасти рақам ба Гараж",
  "garageLifecycle.cleanPreservedLine2": "• Мӯҳлати боқимондаи фаъолсозӣ",
  "garageLifecycle.cleanPreservedLine3": "• Статуси интихобшудаи рақам",
  "garageLifecycle.cleanPreservedLine4": "• Шумораи умумии дидани корти рақам",
  "garageLifecycle.freeFirstHour": "Дар соати аввал ройгон",
  "garageLifecycle.willBecomeUnavailable": "ДАСТНОРАС МЕШАВАД",
  "garageLifecycle.deactivateRemovedLine1": "• Журнали сафар",
  "garageLifecycle.deactivateRemovedLine2": "• Интихоб ва истифодаи статуси рақам",
  "garageLifecycle.deactivateRemovedLine3": "• Шумо худкор аз AutoClan мебароед",
  "garageLifecycle.deactivateRemovedLine4": "• Бозори мошин",
  "garageLifecycle.deactivateRemovedLine5": "• Суғурта",
  "garageLifecycle.deactivateRemovedLine6": "• Пит-стоп",
  "garageLifecycle.deactivateRemovedLine7": "• Кӯмак дар роҳ",
  "garageLifecycle.deactivateRemovedLine8": "• Рақами давлатӣ аз Гараж ҷудо мешавад",
  "garageLifecycle.willRemainAvailable": "ДАСТРАС БОҚӢ МЕМОНАД",
  "garageLifecycle.deactivatePreservedLine1": "• Ҳамсафар",
  "garageLifecycle.deactivatePreservedLine2": "• Диспетчер",
  "garageLifecycle.deactivatePreservedLine3": "• Ҷустуҷӯ ва дидани рақами давлатӣ",
  "garageLifecycle.deactivatePreservedLine4": "  корти оммавии мошин",
  "garageLifecycle.deactivatePreservedLine5": "• Имкони аз нав фаъол кардани",
  "garageLifecycle.deactivatePreservedLine6": "  Гараж дар ҳар вақт",
  "garageLifecycle.cleanConsentLine1": "Розигии худро барои нест кардани",
  "garageLifecycle.cleanConsentLine2": "тамоми таърихи ин рақам",
  "garageLifecycle.cleanConsentLine3": "бе имкони барқароркунӣ тасдиқ мекунам.",
  "garageLifecycle.deactivateConsentLine1": "Ғайрифаъолсозӣ ва қатъи",
  "garageLifecycle.deactivateConsentLine2": "дастрасӣ ба ҳамаи функсияҳои",
  "garageLifecycle.deactivateConsentLine3": "фаъоли Гаражро тасдиқ мекунам.",
  "garageLifecycle.clean": "Тоза кардан",
  "garageLifecycle.deactivate": "Ғайрифаъол кардан",
} satisfies Record<MessageKey, string>
